import { render, staticRenderFns } from "./QuoteCard.vue?vue&type=template&id=165db742&"
import script from "./QuoteCard.vue?vue&type=script&lang=js&"
export * from "./QuoteCard.vue?vue&type=script&lang=js&"
import style0 from "../Invoices/invoice-card.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "QuoteCard.vue"
export default component.exports